import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'rolename' })
export class RoleNamePipe implements PipeTransform {
  transform(role) {

    let rolename = '';

    switch (role) {
      case 1: // worker
        rolename = 'Worker';
        break;
      case 2: // contractor manager
        rolename = 'Contractor';
        break;
      case 3: // site owner
        rolename = 'Site Owner';
        break;
      case 4: // call center
        rolename = 'Call Centre';
        break;
      case 5: // admin
        rolename = 'Admin';
        break;
      case 7:
        rolename = 'Site Delegate';
        break;
      case 9:
        rolename = 'Power Station Owner';
        break;
      case 10:
        rolename = 'Power Station Manager';
        break;
      case 11:
        rolename = 'Control Admin';
        break;
      case 12:
        rolename = 'Regional Manager';
        break;
      case 13:
        rolename = 'Authorising Officer';
        break;
      default:
        rolename = '';
    }
    return rolename;
  }
}
